// Avatar definitions with transparent background images
export const AVATAR_OPTIONS = [
  {
    id: 'male-1',
    name: 'Mr. Kumar',
    description: 'Friendly teacher with glasses & book',
    image: 'https://static.prod-images.emergentagent.com/jobs/a5aa180f-3a09-4867-ba5a-22f56969a148/images/c42c2feac9fa435e5dcfc669cac21d82ceac329b6536153ec230a680b95d9ced.png',
    voiceType: 'male',
  },
  {
    id: 'male-2',
    name: 'Mr. Sharma',
    description: 'Cool teacher with teaching gesture',
    image: 'https://static.prod-images.emergentagent.com/jobs/a5aa180f-3a09-4867-ba5a-22f56969a148/images/3fdda5e82b5f4a0e90c03ce9451f8d7dbd7512045659311b9dc18a4cd85a7868.png',
    voiceType: 'male',
  },
  {
    id: 'male-3',
    name: 'Mr. Patel',
    description: 'Wise professor in brown cardigan',
    image: 'https://static.prod-images.emergentagent.com/jobs/a5aa180f-3a09-4867-ba5a-22f56969a148/images/f18be6e8924785dfc260782e0aba715257e8e94516ee3d68f884a3ee9b1b2bad.png',
    voiceType: 'male',
  },
  {
    id: 'female-1',
    name: 'Ms. Priya',
    description: 'Smart teacher in blue blazer',
    image: 'https://static.prod-images.emergentagent.com/jobs/a5aa180f-3a09-4867-ba5a-22f56969a148/images/e40876dd38ca5b7bd0538016ba92c000957be09ab6b0cb0b7cc8f038f636f755.png',
    voiceType: 'female',
  },
  {
    id: 'female-2',
    name: 'Ms. Ananya',
    description: 'Warm teacher in green kurta',
    image: 'https://static.prod-images.emergentagent.com/jobs/a5aa180f-3a09-4867-ba5a-22f56969a148/images/d6bd632384e1918f6653627737303d320b61b13f022e886ea54845030bb67e6c.png',
    voiceType: 'female',
  },
  {
    id: 'female-3',
    name: 'Ms. Devi',
    description: 'Cheerful teacher in orange saree',
    image: 'https://static.prod-images.emergentagent.com/jobs/a5aa180f-3a09-4867-ba5a-22f56969a148/images/4d53664b63122af5cf2b708b62a7492b269a13d938162860a8e6bdf1c8c87409.png',
    voiceType: 'female',
  },
];

export function getAvatarById(id) {
  return AVATAR_OPTIONS.find(a => a.id === id) || AVATAR_OPTIONS[0];
}
